import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

import { selectUserRegion, useFetchDefaultPromoCodeQuery } from '@/store';
import { SnackbarUtils } from '@/utils';

export const PromoCode = () => {
  const region = useSelector(selectUserRegion);
  const { data: promoCode } = useFetchDefaultPromoCodeQuery({ region });

  const isExpired = promoCode?.expiresAt
    ? new Date(promoCode.expiresAt) < new Date()
    : false;

  if (!promoCode || isExpired) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        background: theme => theme.palette.gradients.promoCode,
        width: '100%',
        p: 2,
        borderRadius: 4,
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Typography
          variant="body1"
          sx={{ textAlign: 'center', color: 'text.contrast' }}>
          {promoCode.name}: Use code{' '}
        </Typography>
        <Box
          sx={{
            border: '1px solid white',
            py: 0.5,
            px: 1,
            borderRadius: 1,
            '&:hover': {
              cursor: 'pointer',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
            mx: 1,
          }}
          onClick={() => {
            navigator.clipboard.writeText(promoCode.code);
            SnackbarUtils.success(
              `Promo code ${promoCode.code} copied to clipboard!`,
            );
          }}>
          <Typography variant="body1SemiBold" color="text.contrast">
            {promoCode.code}
          </Typography>
        </Box>
        <Typography variant="body1" color="text.contrast">
          {' '}
          at checkout to get <b>{promoCode.percentOff}% OFF!</b>
        </Typography>
      </Box>
      {promoCode.expiresAt && (
        <Typography variant="body3" sx={{ color: 'text.contrast' }}>
          Limited time only. This offer expires{' '}
          {format(new Date(promoCode.expiresAt), 'MMMM dd, yyyy')}.
        </Typography>
      )}
    </Box>
  );
};
